import './background.css'

function ColorBack() {
    return(
        <div className='background1'></div>
    )
}

export default ColorBack